import { HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { Store } from '@ngxs/store'
import { AuthState } from '../stores/auth/auth.state'

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const store = inject(Store)
  const newReq = req.clone({
    headers: req.headers.set(
      'Authorization',
      `Bearer ${store.selectSnapshot(AuthState.getToken)}`
    ),
  })
  return next(newReq)
}
